import React, { useEffect, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDarkMode } from '../utils/DarkModeProvider';
import stylesTableDarkMode from '../styles/TableDarkMode'
import stylesTableLightMode from '../styles/TableLightMode'
import { useGlobal } from '../utils/GlobalContext';

export default function InstanciasTablaHeader({ indice_completo, nombre }) {

    const { globalState } = useGlobal()

    const { darkMode } = useDarkMode();

    const dynamicStyles = darkMode ? stylesTableDarkMode : stylesTableLightMode;

    return (
        <thead>
            <tr>
                {globalState && globalState.items.map((item, index) => {
                    return (
                        indice_completo === item.indice_completo && item.instancias.length > 0 &&
                        <React.Fragment key={`item-${index}`}>
                            {item.atributos.map((atributo, index) => {
                                return (
                                    <th key={index} style={{ ...dynamicStyles.header, paddingTop: 4, paddingBottom: 4, fontSize: 12, lineHeight: 1.2, minWidth: 120, maxWidth: 240, whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere', verticalAlign: 'middle' }}>{atributo.nombre}</th>
                                )
                            })}
                            <th style={{ ...dynamicStyles.header, paddingTop: 4, paddingBottom: 4, fontSize: 12, lineHeight: 1.2, minWidth: 84, maxWidth: 84, textAlign: 'center', whiteSpace: 'nowrap', verticalAlign: 'middle' }}>Acciones</th>
                        </React.Fragment>
                    )
                })}
            </tr>
        </thead>
    )
}